module.exports = __webpack_public_path__ + "bs.svg?f88e2401ba07315101ea050e284a2cfc";